"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPromisedResolution = void 0;
// TODO: typescript build then restore (below)
// todo: or maybe switch to: https://github.com/sindresorhus/p-defer
// todo: update/fix broken/skipped test oncet this is improved. (see start-automation-controller.test.ts)
// it doesn't have timeout. p-timeout does, but doesn't externally resolve. So maybe combine them.
// May have missed one: https://github.com/sindresorhus/promise-fun
/**
 * Creates a Promise that can be resolved/rejected externally (vs inside the Promise constructor), plus an option to timeout.
 *
 * @param opts
 * @returns {Promise<unknown>}
 */
function createPromisedResolution(opts = {}) {
    let fancyPromise;
    let extra;
    let _isPending = true;
    let _timer;
    let _done = () => {
        _timer && clearTimeout(_timer);
        _isPending = false;
        // fancyPromise = undefined;
        _done = undefined;
        extra = undefined;
    };
    fancyPromise = new Promise((_resolve, _reject) => {
        extra = {
            resolve: result => {
                if (_isPending) {
                    _done && _done();
                    _resolve(result);
                }
            },
            reject: err => {
                if (_isPending) {
                    _done && _done();
                    _reject(err);
                }
            },
            isPending: () => _isPending,
        };
    });
    Object.assign(fancyPromise, extra);
    const { timeout, onTimeout } = opts;
    if (typeof timeout === 'number' && timeout >= 0) {
        fancyPromise.timer = setTimeout(() => {
            if (_isPending) {
                _isPending = false;
                if (onTimeout) {
                    onTimeout(fancyPromise.resolve, fancyPromise.reject);
                }
                else {
                    const errPayload = opts.timeoutPayload || {
                        error: {
                            errorCode: 'PromiseTimedOut',
                            reason: 'Promise timed out',
                            expiredAt: Date.now(),
                            durationMs: timeout,
                        }
                    };
                    fancyPromise.resolve(errPayload);
                }
            }
        }, timeout);
        // fancyPromise.finally(() => {
        //   clearTimeout(fancyPromise.timer);
        //   _isPending = false;
        // });
    }
    return fancyPromise;
}
exports.createPromisedResolution = createPromisedResolution;
//# sourceMappingURL=promised-resolution.js.map